class DigitalMarketSlider extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-dm-slide]')];
    this.dots = [...this.querySelectorAll('[data-dm-dot]')];
    this.current = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
    this.interval = Math.max(4000, Number(this.dataset.interval || 7) * 1000);
    this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;

    this.querySelector('[data-dm-previous]')?.addEventListener('click', () => this.show(this.current - 1));
    this.querySelector('[data-dm-next]')?.addEventListener('click', () => this.show(this.current + 1));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    this.editorSelectHandler = (event) => {
      const target = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
      if (target) this.show(this.slides.indexOf(target));
    };
    document.addEventListener('shopify:block:select', this.editorSelectHandler);
    this.show(this.current, false);
    this.start();
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('shopify:block:select', this.editorSelectHandler);
  }

  show(index, restart = true) {
    if (!this.slides.length) return;
    this.current = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, slideIndex) => {
      const active = slideIndex === this.current;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (active) slide.removeAttribute('inert');
      else slide.setAttribute('inert', '');
    });
    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === this.current;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
    if (restart) {
      this.stop();
      this.start();
    }
  }

  start() {
    if (!this.autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.stop();
    this.timer = window.setInterval(() => this.show(this.current + 1, false), this.interval);
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }
}

if (!customElements.get('dm-slider')) {
  customElements.define('dm-slider', DigitalMarketSlider);
}
